import WebFont from 'webfontloader';
//import $ from 'jquery'; // Uncomment jquery import statement if you want to use $

/**
 * Lazyload fonts with WebFontLoader
 */
WebFont.load({
  google: {
    families: ['Roboto', 'Material Icons'],
  },
});

/**
 * Lazyload images
 * Add simple support for background images
 */
document.addEventListener('lazybeforeunveil', function(e) {
  let bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
});



// WEBPACK FOOTER //
// ./scripts/components/common.js